const STORAGE_PREFIX = 'assistantLauncherLabelSeen:';

export type LauncherLabelUserId = number | string | null | undefined;

export const launcherLabelKey = (userId: LauncherLabelUserId): string | null => {
  const id = typeof userId === 'number' ? String(userId) : userId?.trim();
  return id ? `${STORAGE_PREFIX}${id}` : null;
};

export const hasSeenLauncherLabel = (userId: LauncherLabelUserId): boolean => {
  const key = launcherLabelKey(userId);
  if (!key) return false;
  try {
    return window.localStorage.getItem(key) === '1';
  } catch {
    return false;
  }
};

export const markLauncherLabelSeen = (userId: LauncherLabelUserId): void => {
  const key = launcherLabelKey(userId);
  if (!key) return;
  try {
    window.localStorage.setItem(key, '1');
  } catch {
    return;
  }
};
